// extracted by mini-css-extract-plugin
module.exports = {"infoWrapper":"ClientEmergencyInfo_infoWrapper__2tHs7","itemTitle":"ClientEmergencyInfo_itemTitle__moAYu","itemText":"ClientEmergencyInfo_itemText__2HWQr"};